export default __webpack_public_path__ + "static/media/yashas_profile.f6521954.jpg";